
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/walks",
      function () {
        return require("private-next-pages/walks/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/walks"])
      });
    }
  